/**
 * @file Constants for Product Combo feature
 */
import {COUNTRY_CODES} from '@/utils/constants/countryConstants'

/**
 * Business group options for Snacks & Beverages selection
 * @type {Array<{id: string, displayText: string}>}
 */
export const BUSINESS_GROUP_OPTIONS = [
  {id: 'SNK', displayText: 'Snacks'},
  // {id: 'BVG', displayText: 'Beverages'},
]

/**
 * Business group display names mapping
 * @type {Object<string, string>}
 */
export const BUSINESS_GROUP_LABELS = {
  SNK: 'Snacks',
  BVG: 'Beverages',
}

/**
 * Business group labels available per country. Countries not listed here don't support
 * business group filtering, so it should be hidden from the UI and not applied as a filter.
 * @type {Record<string, Object<string, string>>}
 */
export const COUNTRY_BUSINESS_GROUP_LABELS = {
  [COUNTRY_CODES.US]: BUSINESS_GROUP_LABELS,
}
